import { TableStateType } from '@/@types/table.types';
import { create } from 'zustand';

export const tableStore = create<TableStateType>((set) => ({
  currentPage: 1,
  pageSize: 10,
  searchTerm: '',
  options: [],
  setOptions: (totalData: number, options?: string[]) => {
    set((state) => {
      let min = 10;
      let max = 50;
      const generatedOptions = [];

      max = Math.ceil(totalData / min);
      for (let x = 1; x <= max; x++) {
        generatedOptions.push(`${x * 10}`);
      }

      return {
        options: options?.length ? options : generatedOptions,
      };
    });
  },
  setCurrentPage: (currentPage: number) => set((state) => ({ currentPage })),
  setPageSize: (pageSize: number) => set((state) => ({ pageSize })),
  setSearchTerm: (keyword: string) => set((state) => ({ searchTerm: keyword })),
  totalPages: 0,
  setTotalPages: (totalPages: number) => {
    set((state) => ({ totalPages }));
  },
}));
